<template>
  <el-card shadow="always" class="p-0">
    <div class="row">
      <div class="col-12 p-0">
        <h3 class="mb-0 text-navy mx-1">Action Items</h3>
        <el-table :data="actionItems" class="fa-sm">
          <el-table-column label="Task" prop="subject" />
          <el-table-column label="Action" prop="description" width="250" />
          <el-table-column label="Assigned To" prop="assign_to.full_name" />
          <el-table-column label="" prop="name" width="50">
            <template slot-scope="scope">
              <a href="#" class="pr-2" alt="Mark as completed" @click="onSubmit(scope.row)"><i
                  class="fa fa-check fa-lg"></i></a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-card>
</template>
<script>

import Task from "../../../modelsPortal/Task";
export default {
  props: {
  },
  mounted() {
    this.getTasks();
  },
  data() {
    return {
      actionItems: [],
      loading: false,
    };
  },
  methods: {
    getTasks() {
      this.loading = true;

      let tasks = Task.include("assignTo")
        .select('id', 'subject', 'description', 'assign_to_id');

      tasks
        .get()
        .then((res) => {
          this.loading = false;
          this.actionItems = res;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    onSubmit(task) {
      this.$confirm("Are you sure you want to mark as completed this task?", "Info",
        {
          confirmButtonText: "Complete",
          cancelButtonText: "Cancel",
          type: "info"
        })
        .then((_) => {
          let completeTask = {
            id: task.id,
            is_completed: true
          };
          new Task(completeTask).save().then((result) => {
            this.$message({
              type: "success",
              message: "Task marked as complete.",
            });
            this.getTasks();
          }).catch((err) => {
            this.$message({
              type: "error",
              message: "Looks like something went wrong.",
            });
          });
        })
        .catch((_) => { });
    }
  },
};
</script>
